import { render, staticRenderFns } from "./UserPrivacy.vue?vue&type=template&id=f06229d8&"
import script from "./UserPrivacy.vue?vue&type=script&lang=js&"
export * from "./UserPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports